import bulleEuroContoursVerts from '../../../assets/bulle-euro-contours-verts.svg'
import checklistContoursVerts from '../../../assets/checklist-contours-verts.svg'
import devisContoursVerts from '../../../assets/devis-contours-verts.svg'

export const data = [
  {
    icon: bulleEuroContoursVerts,
    title: '1. Rappel de votre conseiller',
    subtitle: 'Estimation du prix de votre déménagement',
    text: '3 minutes au téléphone avec votre conseiller vous permettra d’obtenir l’estimation du prix de votre déménagement.',
  },
  {
    icon: checklistContoursVerts,
    title: '2. Visioconférence',
    subtitle: 'Etude technique avec votre expert dédié',
    text: 'Une seule étude suffit pour réaliser un cahier des charges complet et mettre en concurrence nos 250 déménageurs professionnels.',
  },
  {
    icon: devisContoursVerts,
    title: '3. Mise en relation',
    subtitle: 'Réception de 3 à 6 devis de déménageurs.',
    text: 'Sur les conseils de votre expert Nextories, vous choisissez votre société de déménagement professionnel en toute sérénité.',
  },
]
